export function moveItemByIndex<T>(
  items: T[],
  fromIndex: number,
  toIndex: number,
) {
  if (fromIndex === toIndex) return items;
  if (fromIndex < 0 || fromIndex >= items.length) return items;
  if (toIndex < 0 || toIndex >= items.length) return items;

  const nextItems = [...items];
  const [movedItem] = nextItems.splice(fromIndex, 1);
  if (movedItem === undefined) return items;

  nextItems.splice(toIndex, 0, movedItem);
  return nextItems;
}
